
;
                (function(){
                    const Func = (function() {
                        this.isLive&&window.location.pathname.includes("challenge")&&setTimeout(function(){var e=document.querySelector(".shopify-challenge__container");console.log(e),e.scrollIntoView()},100)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-q0lkkv6swcl';
                    document.querySelectorAll('.ecom-q0lkkv6swcl').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link");t.length&&t.forEach(function(n){var r=n.getAttribute("href")||"#",i=r.replace("{current-link}",location.href);n.setAttribute("href",i)})}
                    
                    });
                    const settings = {};
                    const ID = 'ecom-lw2sk1bw7w';
                    document.querySelectorAll('.ecom-lw2sk1bw7w').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            